import SmoothScroll from 'smoothscroll-for-websites/SmoothScroll';

$(function() {
    new SmoothScroll({
        // Scrolling Core
        animationTime: 400, stepSize: 80,

        // Acceleration
        accelerationDelta: 50, accelerationMax: 3,

        // Keyboard Settings
        keyboardSupport: true, arrowScroll: 50,

        // Pulse (less tweakable)
        // ratio of "tail" to "acceleration"
        pulseAlgorithm: true,
        pulseScale: 4,
        pulseNormalize: 1,

        // Other
        touchpadSupport: false, // ignore touchpad by default
        fixedBackground: true,
        excluded: ''
    });

    $('.lazy').Lazy();
});

export function setCarouselWidth(container) {
    let conteinerMR = parseInt($('.page-container').css('margin-right')),
        containerPR = parseInt($('.page-container').css('padding-right')),
        conteinerW = parseInt($(`.${container}`).css('width')),
        carouselWidth = conteinerMR + containerPR + conteinerW;
    $(`.${container}`).css('width', `${String(carouselWidth)}px`);
}

export function countSlides(slider, statusEl) {
    return slider.on('init reInit afterChange', function(event, slick, currentSlide) {
        let i = (currentSlide ? currentSlide : 0) + 1;
        statusEl.html(`
        ${i < 10 ? '0' + i : i} 
        / ${slick.slideCount < 10 
            ? '0' + slick.slideCount 
            : slick.slideCount}
            `);
    });
}

export function progressSlides(slider, progressEl) {
    slider.on('init', function(event, slick) {
        let calc = 100 / slick.slideCount;
        progressEl.css('width', `${calc}%`);
    }).on('afterChange', function(event, slick, currentSlide) {
        let calc = (100 * (currentSlide + 1)) / slick.slideCount;
        progressEl.css('width', `${calc}%`);
    });
}